import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { project } from "../../store/project/actions";
export var GetProjectAll = function (trigger, enable, page, limit, sponsorId, description) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responseProject: state.Project.responseProject,
        errorProject: state.Project.errorProject,
        loadingProject: state.Project.loadingProject,
    }); }), responseProject = _a.responseProject, errorProject = _a.errorProject, loadingProject = _a.loadingProject;
    useEffect(function () {
        if (trigger) {
            dispatch(project({
                enable: enable,
                page: page,
                limit: limit,
                sponsorId: sponsorId,
                description: description,
            }));
        }
    }, [sponsorId, enable, limit, page, trigger, description]);
    return {
        responseProject: responseProject,
        errorProject: errorProject,
        loadingProject: loadingProject,
    };
};
